import IntroductionBoxes from "./IntroductionBoxes";
import IntroductionCopy from "./IntroductionCopy";

const Introduction = () => {
    return ( 

        <section className="introductionContainer">
            <IntroductionCopy/>
            <IntroductionBoxes/>
        </section>


     );
}
 
export default Introduction;